/**
 * Early returning-customer guard — loads synchronously (no defer) right after the
 * config JSON so the Loop /account/check call starts before the main configurator
 * bundle parses.
 */
(function () {
  var Modal = window.OttoCfgPlanModal;
  if (!Modal) return;

  var cfgNode = document.querySelector('[data-otto-cfg-config]');
  if (!cfgNode) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgNode.textContent || '{}');
  } catch (e) {
    return;
  }

  var customer = cfg.customer || {};
  var urls = cfg.urls || {};
  if (!customer.loggedIn) return;

  var email = String(customer.email || '').trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

  var workerUrl = String(cfg.workerUrl || '').replace(/\/$/, '');
  var hasMetaHint = !!customer.hasOttoPlan;

  window.__ottoPlanPrefetch = {
    email: email,
    hasMetaHint: hasMetaHint,
    done: false,
    result: null,
    planStatus: null,
    promise: null,
  };

  function modalOpts(planStatus, firstName) {
    return {
      planStatus: planStatus,
      loggedIn: true,
      firstName: firstName || customer.firstName || '',
      emailVal: email,
      urls: urls,
      onStartFresh: function () {
        var logoutBase = urls.logout || '/account/logout';
        var returnPath = window.location.pathname + window.location.search;
        var sep = logoutBase.indexOf('?') >= 0 ? '&' : '?';
        window.location.href = logoutBase + sep + 'return_url=' + encodeURIComponent(returnPath);
      },
    };
  }

  function finishCheck(parsed) {
    window.__ottoPlanPrefetch.done = true;
    window.__ottoPlanPrefetch.result = !!(parsed && parsed.existingOttoPlan);
    window.__ottoPlanPrefetch.planStatus = parsed ? parsed.planStatus : null;
    window.__ottoPlanPrefetch.firstName = parsed && parsed.firstName ? parsed.firstName : '';
    if (parsed && parsed.existingOttoPlan) {
      Modal.show(modalOpts(parsed.planStatus, parsed.firstName));
    } else if (hasMetaHint) {
      Modal.show(modalOpts('ACTIVE', customer.firstName || ''));
      window.__ottoPlanPrefetch.result = true;
      window.__ottoPlanPrefetch.planStatus = 'ACTIVE';
    } else {
      Modal.dismiss();
    }
  }

  if (hasMetaHint) {
    Modal.show(modalOpts('ACTIVE', customer.firstName || ''));
  } else {
    Modal.showChecking();
  }

  if (!workerUrl) {
    finishCheck(hasMetaHint ? { existingOttoPlan: true, planStatus: 'ACTIVE', firstName: customer.firstName || '' } : { existingOttoPlan: false, planStatus: null, firstName: '' });
    return;
  }

  var p = fetch(workerUrl + '/account/check', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email }),
  })
    .then(function (res) { return res.json(); })
    .then(function (data) { return Modal.parseAccountCheckResponse(data); })
    .catch(function () {
        return hasMetaHint
        ? { existingOttoPlan: true, planStatus: 'ACTIVE', firstName: customer.firstName || '' }
        : { existingOttoPlan: false, planStatus: null, firstName: '' };
    });

  window.__ottoPlanPrefetch.promise = p;
  p.then(finishCheck);
})();
